<template>
    <div>
        <div v-if="!configModalEditPage.model" class="col-lg-12">
            <div v-if="isPageTypeId" :index="idxChangePropertiesPage">
                <div v-for="(item, idxGroup) in pagesGrouped" :key="idxGroup">
                    <div v-if="item.is_group" class="form-group row">
                        <div
                            class="col-sm-6 mb-3"
                            :style="dataForm.page_type.id === 2 ? 'background-color: #fdf5f0; border-radius: 20px; padding: 12px' : ''"
                        >
                            <div v-if="dataForm.page_type.id === 2" class="mb-3 font-weight-bold" style="font-size: 16px">
                                当選者（現物）用の個人情報登録フォームです。<br />※賞品がデジタルギフトのみの場合は設定不要
                            </div>
                            <div v-for="(master_page, gIdx) in item.pages" :key="gIdx" class="mb-3">
                                <div :style="`opacity: ${master_page?.is_disabled ? '0.5' : '1'}`">
                                    <label
                                        class="text-nowrap p-2"
                                        style="width: 100%; background-color: #dadad9; font-weight: 900; min-width: fit-content"
                                        >{{ master_page.title }}</label
                                    >
                                    <div v-for="(page, k) in master_page.page_child" :key="k">
                                        <label
                                            class="mt-2 ml-3"
                                            :style="`cursor:${master_page?.is_disabled ? 'not-allowed' : 'pointer'}; color: #5664d2;`"
                                            @click="handleEditFormInput(master_page, page, master_page.originalIdx, k)"
                                        >
                                            {{ page.name_page }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="form-group row">
                        <div class="col-sm-6" :style="`opacity: ${item.page?.is_disabled ? '0.5' : '1'}`">
                            <label class="text-nowrap p-2" style="width: 100%; background-color: #dadad9; font-weight: 900; min-width: fit-content">{{
                                item.page.title
                            }}</label>
                            <div v-for="(page, k) in item.page.page_child" :key="k">
                                <label
                                    class="col-sm-3 mt-2"
                                    :style="`min-width: 150px; cursor:${item.page?.is_disabled ? 'not-allowed' : 'pointer'}; color: #5664d2; max-width: 100%`"
                                    @click="handleEditFormInput(item.page, page, item.originalIdx, k)"
                                >
                                    {{ page.name_page }}
                                </label>
                            </div>
                        </div>
                        <div v-if="item.page.is_accept_add" class="col-sm-9"></div>
                    </div>
                </div>
                <!-- <div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.specifiedNumberOfApplicationsEndScreen')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.specified_number_of_applications_end_screen"
                                    :id="`check-specifiedNumberOfApplicationsEndScreen`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.screenBeforeApplicationPeriodStarts')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.screen_before_application_period_starts"
                                    :id="`check-screenBeforeApplicationPeriodStarts`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.applicationPeriodEndScreen')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.application_period_end_screen"
                                    :id="`check-applicationPeriodEndScreen`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.unknownError') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.unknown_error"
                                    :id="`check-unknownError`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.login') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox :model.sync="settingPageForm.setting_page.login" :id="`check-login`" :value="false" :label="``" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.mypage') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox :model.sync="settingPageForm.setting_page.my_page" :id="`check-Mypage`" :value="false" :label="``" />
                            </div>
                        </div>
                    </div> -->
            </div>
        </div>
        <ModalAddPage :configModal="configModalAddPage" />
        <modalEditPage
            ref="modalEditPage"
            :dataForm="dataForm"
            :configModal="configModalEditPage"
            @updateConfig="onHandleConfigEditPage"
            @updateBlockForm="onHandleUpdateBlockForm"
        />
    </div>
</template>

<script>
import { configModalAddPage, configModalEditPage } from './constants';
import { validateField } from '@/utils/validate';
// import { InputRadio, InputCheckBox } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';
import { cloneDeep } from 'lodash';

import ModalAddPage from './components/modal-add-page.vue';
import modalEditPage from './components/modal-edit-page.vue';

export default {
    name: 'SettingPage',
    components: {
        ModalAddPage,
        modalEditPage
        // InputCheckBox,
        // InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        },
        listPage: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            configModalAddPage: configModalAddPage,
            configModalEditPage: configModalEditPage(),
            settingPageForm: cloneDeep(this.dataForm),
            idxChangePropertiesPage: 0
        };
    },
    computed: {
        pagesGrouped() {
            const pages = this.settingPageForm.setting_page?.pages || [];
            const groupTitles = ['入力画面', '確認画面', '完了画面'];
            const result = [];
            let currentGroup = null;

            pages.forEach((page, originalIdx) => {
                if (groupTitles.includes(page.title)) {
                    if (!currentGroup) {
                        currentGroup = {
                            is_group: true,
                            pages: []
                        };
                        result.push(currentGroup);
                    }
                    currentGroup.pages.push({ ...page, originalIdx });
                } else {
                    currentGroup = null;
                    result.push({
                        is_group: false,
                        page: page,
                        originalIdx
                    });
                }
            });
            return result;
        },
        isPageTypeId() {
            return this.dataForm.page_type?.id ? true : false;
        }
    },
    methods: {
        ...managerFormMethods,

        handleValidateField(configField) {
            validateField(configField);
        },

        handleAddFormInput(obj) {
            this.configModalAddPage.model = true;
            this.configModalAddPage.pageAdd = obj.page_child;
        },

        handleEditFormInput(master_obj, obj, idx, k) {
            if (master_obj?.is_disabled) return;
            const getPageEdit = JSON.parse(localStorage.getItem('typePageWl'));
            if (getPageEdit) {
                localStorage.setItem('typePageWl', JSON.stringify({ ...getPageEdit, name_edit: obj.type_page_wl }));
            }
            localStorage.setItem('activePage', true);

            this.configModalEditPage.model = true;
            this.configModalEditPage.id = `edit_page-${idx}_${k}`;
            this.configModalEditPage.title = obj.name_page;
            this.configModalEditPage.parentPage = master_obj;
            this.configModalEditPage.childPage = obj;
            this.updateBlockList(obj.blocks);
            this.updateButtonEvent({ eventEditButton: false, eventEditPage: true });
        },
        onHandleUpdateBlockForm(evtUpdate) {
            let { idParentPage, idChildPage, listBlockNotDelete } = evtUpdate;
            const foundSetPage = this.settingPageForm.setting_page.pages.find((masterItem) => masterItem?.id === idParentPage);
            if (!foundSetPage) return;
            const foundBlockPage = foundSetPage.page_child?.find((childPageItem) => childPageItem?.id === idChildPage);
            if (!foundBlockPage) return;
            foundBlockPage.blocks = listBlockNotDelete;
            this.$emit('update:dataForm', this.settingPageForm);
        },

        handleDeleteFormInput(k, arrayPage) {
            arrayPage.splice(k, 1);
        },

        onHandleConfigEditPage(evtConfig) {
            const { parentPage, childPage, title } = evtConfig;
            const foundMasterPage = this.settingPageForm.setting_page.pages.find((masterItem) => masterItem?.id === parentPage?.id);
            if (!foundMasterPage) {
                console.warn(`Master page with id ${parentPage?.id} not found`);
                return;
            }
            const foundChildPage = foundMasterPage.page_child?.find((childPageItem) => childPageItem?.id === childPage?.id);
            if (!foundChildPage) {
                console.warn(`Child page with id ${childPage.id} not found`);
                return;
            }
            foundChildPage.name_page = title;
            this.updateButtonEvent({ eventEditPage: false });
            this.$emit('update:dataForm', this.settingPageForm);
        },

        onHandleCloseSettingBlock() {
            this.configModalEditPage.model = false;
        },
        onUpdateBlockList() {
            const getPageEdit = JSON.parse(localStorage.getItem('typePageWl'));
            const getCurrentTab = localStorage.getItem('currentTabForm');
            const getActivePage = localStorage.getItem('activePage');
            if (getPageEdit?.id && getCurrentTab && getActivePage) {
                if (getPageEdit.id === this.$route.query.id && getCurrentTab === getPageEdit.tab_name) {
                    this.settingPageForm.setting_page.pages.forEach((masterItem) => {
                        masterItem.page_child.forEach((childItem) => {
                            if (childItem.type_page_wl === getPageEdit.name_edit) {
                                this.handleEditFormInput(masterItem, childItem, masterItem.id, childItem.id);
                            }
                        });
                    });
                }
            }
        }
    },

    watch: {
        dataForm: {
            handler(newVal) {
                this.settingPageForm = newVal;
                this.onUpdateBlockList();
            },
            deep: true
        },

        settingPageForm: {
            handler(newVal) {
                this.$emit('update:dataForm', newVal);
            },
            immediate: true,
            deep: true
        },

        'dataForm.setting_lottery': {
            handler(newVal) {
                this.settingPageForm.setting_page.pages.forEach((page) => {
                    if (page.title === '落選画面') {
                        page.is_disabled = newVal?.is_prize_before_the_draw;
                    }
                });
                this.idxChangePropertiesPage++;
            },
            deep: true
        },

        'dataForm.serial_code_prizes': {
            handler(newVal) {
                const isAllType1 = newVal && newVal.length > 0 && newVal.every((item) => item.prize_type === 1);
                this.settingPageForm.setting_page.pages.forEach((page) => {
                    if (['入力画面', '確認画面', '完了画面'].includes(page.title)) {
                        page.is_disabled = isAllType1;
                    }
                });
                this.idxChangePropertiesPage++;
            },
            immediate: true,
            deep: true
        }
    },

    mounted() {
        this.onUpdateBlockList();
    },
    destroyed() {
        this.onHandleCloseSettingBlock();
    }
};
</script>

<style lang="scss" scoped>
.popupw {
    font-size: 20px;
    &:hover {
        opacity: 0.8;
    }
}
.namePage {
    &:hover {
        opacity: 0.7;
    }
}
</style>
